<div #bounds class="quick-navigation__bounds" aria-hidden="true"></div>
<div #panelBounds class="quick-navigation__bounds quick-navigation__bounds--panel" [attr.data-edge]="position.edge" aria-hidden="true"></div>
<button #handle type="button" class="quick-navigation__handle"
  [attr.data-edge]="position.edge"
  [style.--quick-navigation-alpha]="(100 - transparency) / 100"
  [class.quick-navigation__handle--vertical]="!horizontal" [class.quick-navigation__handle--dragging]="dragging"
  [hidden]="!visible" [style.left.px]="handlePoint.x" [style.top.px]="handlePoint.y"
  [attr.aria-label]="'shell.quickNavigation.open' | translate"
  [attr.title]="'shell.quickNavigation.hint' | translate"
  aria-haspopup="dialog" [attr.aria-expanded]="open" aria-controls="quick-navigation-panel"
  (touchstart)="$event.stopPropagation()" (mousedown)="$event.stopPropagation()"
  (pointerdown)="onPointerDown($event)" (pointermove)="onPointerMove($event)" (pointerup)="onPointerUp($event)"
  (pointercancel)="cancelPointer()" (lostpointercapture)="cancelPointer()"
  (contextmenu)="$event.preventDefault()" (click)="onHandleClick($event)" (keydown)="onHandleKey($event)">
  <ion-icon [name]="chevron" aria-hidden="true"></ion-icon>
</button>
<dialog #panel id="quick-navigation-panel" data-sm-modal class="quick-navigation__panel"
  [attr.data-edge]="position.edge"
  [class.quick-navigation__panel--vertical]="!horizontal" [style.left.px]="panelPoint.x" [style.top.px]="panelPoint.y"
  [attr.aria-label]="'shell.quickNavigation.title' | translate" (cancel)="onCancel($event)" (click)="onPanelClick($event)">
  <nav [attr.aria-label]="'shell.quickNavigation.title' | translate">
    @for (item of items; track item.id) {
      <a [href]="item.routeHref" [attr.aria-current]="item.id === selectedId ? 'page' : null"
        (click)="onNavigate($event, item)">
        <ion-icon [name]="item.iconName" aria-hidden="true"></ion-icon>
        <span>{{ item.text }}</span>
      </a>
    }
  </nav>
</dialog>
